module.exports = __webpack_public_path__ + "img/16.108cd473.png";